<template>
  <div class="list">
    <div>微信页面</div>
    <a
      href="http://www.beian.miit.gov.cn/"
      target="_blank"
      rel="nofollow"
    >{{ $t("home.icp") }}</a>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  components: {},
  mounted() {},
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    const ua = window.navigator.userAgent.toLowerCase()
    // eslint-disable-next-line
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      next({ path: '/index' })
    } else {
      next()
    }
  }
}
</script>
